import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getProductsList } from '../http/products';
import { ProductDto } from 'desk-common';

export const useProducts = (
  filters: Partial<ProductDto>,
  options?: Omit<
    UseQueryOptions<
      ProductDto[],
      Error,
      ProductDto[],
      readonly [string, Partial<ProductDto>]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['products', filters],
    queryFn: getProductsList,
    ...options,
  });
};
